import type { InterventionProps } from "../../types";
import { usePreload } from "../../hooks";
import { TradeBasedPopup, homebuilder } from "../../components/TradeBased";

export const getMainText = (amount: string) => {
  return `Over the last 2 years, the average claim was ${amount} for someone in your trade. 93% of settled claims get processed in less than 48 hours.*`;
};

export const getFinePrint = (trade: string, amount: string) => {
  return `*The average claim value for ${trade} between 1st January 2023 and 31st December 2024 was ${amount}. We define settled claims as a claim that has been agreed by all parties that a payment can be made. It can take longer from a claim being raised to it being settled and paid.`;
};

export const TradeBasedAverageClaims = (props: InterventionProps) => {
  usePreload(homebuilder);
  const { data } = props;

  if (
    !data?.contextData ||
    !data?.contextData?.ClaimsText ||
    !data?.contextData?.PluralizedFriendlyTradeName
  )
    return null;

  const claimsAmount = data.contextData.ClaimsText as string;
  const tradeName = data.contextData.PluralizedFriendlyTradeName as string;

  return (
    <TradeBasedPopup
      {...props}
      mainText={getMainText(claimsAmount)}
      finePrint={getFinePrint(tradeName, claimsAmount)}
    />
  );
};
